const assetLookup = (assetType) =>
	({
		CONDUIT: 'conduit',
		JUNCTION: 'junction',
		ORIFICE: 'orifice',
		OUTFALL: 'outfall',
		PUMP: 'pump',
		'RAIN GAUGE': 'rain_gauge_2', // or 'rain_gauge'
		RESERVOIR: 'reservoir',
		STORAGE: 'storage_tank',
		VALVE: 'valve',
		WEIR: 'weir',
	})[assetType];

const stateLookup = (assetState) =>
	({
		IMPACTED: 'impacted',
		AT_RISK: 'at_risk',
		OFFLINE: 'offline',
		ONLINE: 'online',
	})[assetState];

const getIconUrl = (assetType, assetState = 'ONLINE') => {
	const baseUrl = '/img/nwlIcons';
	const fileType = '.png';

	const assetName = assetLookup(assetType);
	const state = stateLookup(assetState);

	return `${baseUrl}/${assetName}_${state}${fileType}`;
};

const svgIconCache = new Map();

const getSvgIconUrl = async (assetType, assetState = 'ONLINE') => {
	const cacheKey = `${assetType}|${assetState}`;
	const cached = svgIconCache.get(cacheKey);
	if (cached) return cached;

	const promise = (async () => {
		const assetName = assetLookup(assetType);
		if (!assetName) {
			return 'data:image/svg+xml;base64,';
		}

		const url = `/img/nwlIcons/new/${assetName}.svg`;
		const response = await fetch(url);

		if (!response.ok) {
			return 'data:image/svg+xml;base64,';
		}

		const data = await response.text();

		let svg;
		if (assetState === 'ONLINE') {
			svg = createOnlineIcon(data);
		} else if (assetState === 'IMPACTED') {
			svg = createImpactedIcon(data);
		} else if (assetState === 'AT_RISK') {
			svg = createAtRiskIcon(data);
		} else {
			svg = createOfflinelIcon(data);
		}

		const base64 = btoa(svg);
		return `data:image/svg+xml;base64,${base64}`;
	})();

	svgIconCache.set(cacheKey, promise);
	return promise;
};

// NOTE: Some alternate dimensions for the child SVG:
// <svg width="40" height="30" viewBox="0 -6 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
const createOnlineIcon = (svg) => {
	return `
        <svg width="100" height="100" viewBox="0 0 32 46" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path opacity="0.25" d="M23.7411 43.9124C23.7458 44.1035 23.5614 44.2929 23.1986 44.4697C22.8357 44.6465 22.3015 44.8072 21.6267 44.9427C20.9519 45.0781 20.1497 45.1856 19.2663 45.2589C18.3828 45.3323 17.4356 45.37 16.4789 45.37C15.5222 45.37 14.5749 45.3323 13.6915 45.2589C12.808 45.1856 12.0059 45.0781 11.331 44.9427C10.6562 44.8072 10.122 44.6465 9.75917 44.4697C9.39631 44.2929 9.21194 44.1035 9.21664 43.9124C9.21194 43.7214 9.39631 43.532 9.75917 43.3552C10.122 43.1784 10.6562 43.0176 11.331 42.8822C12.0059 42.7467 12.808 42.6393 13.6915 42.5659C14.5749 42.4926 15.5222 42.4548 16.4789 42.4548C17.4356 42.4548 18.3828 42.4926 19.2663 42.5659C20.1497 42.6393 20.9519 42.7467 21.6267 42.8822C22.3015 43.0176 22.8357 43.1784 23.1986 43.3552C23.5614 43.532 23.7458 43.7214 23.7411 43.9124Z" fill="#74788D" />
            <path d="M15.9967 0.5L15.9961 0.500001C7.44403 0.511822 0.5 7.33046 0.5 15.758C0.5 21.3296 3.53649 26.1989 8.0632 28.8613C12.229 31.9189 15.0443 36.6447 15.4894 42.0262L15.4989 42.1411L15.5578 42.2403L15.5667 42.2552L15.5677 42.257L15.9191 43.1208L16.4329 42.2552L16.4418 42.2403L16.5006 42.1412L16.5101 42.0263C16.9557 36.6442 19.7707 31.9187 23.9368 28.8614C28.4638 26.1993 31.5 21.3296 31.5 15.758C31.5 7.33045 24.556 0.511913 16.0039 0.500001L16.0039 0.500001L15.9998 0.500001L15.9974 0.500001H15.9969L15.9967 0.5Z" fill="white" stroke="white" />
            <path d="M29 16C29 19.4478 27.6304 22.7544 25.1924 25.1924C22.7544 27.6304 19.4478 29 16 29C12.5522 29 9.24558 27.6304 6.80761 25.1924C4.36964 22.7544 3 19.4478 3 16C3 12.5522 4.36964 9.24559 6.80761 6.80761C9.24558 4.36964 12.5522 3 16 3C19.4478 3 22.7544 4.36964 25.1924 6.80761C27.6304 9.24559 29 12.5522 29 16Z" fill="#62D3AA" />
            ${svg}
            <circle cx="16" cy="16" r="14" stroke="white" stroke-width="2" />
        </svg>
    `;
};

const createImpactedIcon = (svg) => {
	return `
        <svg width="100" height="100" viewBox="0 0 32 46" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path opacity="0.25" d="M23.7411 43.9124C23.7458 44.1035 23.5614 44.2929 23.1986 44.4697C22.8357 44.6465 22.3015 44.8072 21.6267 44.9427C20.9519 45.0781 20.1497 45.1856 19.2663 45.2589C18.3828 45.3323 17.4356 45.37 16.4789 45.37C15.5222 45.37 14.5749 45.3323 13.6915 45.2589C12.808 45.1856 12.0059 45.0781 11.331 44.9427C10.6562 44.8072 10.122 44.6465 9.75917 44.4697C9.39631 44.2929 9.21194 44.1035 9.21664 43.9124C9.21194 43.7214 9.39631 43.532 9.75917 43.3552C10.122 43.1784 10.6562 43.0176 11.331 42.8822C12.0059 42.7467 12.808 42.6393 13.6915 42.5659C14.5749 42.4926 15.5222 42.4548 16.4789 42.4548C17.4356 42.4548 18.3828 42.4926 19.2663 42.5659C20.1497 42.6393 20.9519 42.7467 21.6267 42.8822C22.3015 43.0176 22.8357 43.1784 23.1986 43.3552C23.5614 43.532 23.7458 43.7214 23.7411 43.9124Z" fill="#74788D"/>
            <path d="M15.9967 0.5L15.9961 0.500001C7.44403 0.511822 0.5 7.33046 0.5 15.758C0.5 21.3296 3.53649 26.1989 8.0632 28.8613C12.229 31.9189 15.0443 36.6447 15.4894 42.0262L15.4989 42.1411L15.5578 42.2403L15.5667 42.2552L15.5677 42.257L15.9191 43.1208L16.4329 42.2552L16.4418 42.2403L16.5006 42.1412L16.5101 42.0263C16.9557 36.6442 19.7707 31.9187 23.9368 28.8614C28.4638 26.1993 31.5 21.3296 31.5 15.758C31.5 7.33045 24.556 0.511913 16.0039 0.500001L16.0039 0.500001L15.9998 0.500001L15.9974 0.500001H15.9969L15.9967 0.5Z" fill="white" stroke="white"/>
            <path d="M29 16C29 19.4478 27.6304 22.7544 25.1924 25.1924C22.7544 27.6304 19.4478 29 16 29C12.5522 29 9.24558 27.6304 6.80761 25.1924C4.36964 22.7544 3 19.4478 3 16C3 12.5522 4.36964 9.24559 6.80761 6.80761C9.24558 4.36964 12.5522 3 16 3C19.4478 3 22.7544 4.36964 25.1924 6.80761C27.6304 9.24559 29 12.5522 29 16Z" fill="#F46A6A"/>
            ${svg}
            <circle cx="16" cy="16" r="14" stroke="white" stroke-width="2"/>
        </svg>
    `;
};

const createAtRiskIcon = (svg) => {
	return `
        <svg width="100" height="100" viewBox="0 0 32 46" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path opacity="0.25" d="M23.7411 43.9124C23.7458 44.1035 23.5614 44.2929 23.1986 44.4697C22.8357 44.6465 22.3015 44.8072 21.6267 44.9427C20.9519 45.0781 20.1497 45.1856 19.2663 45.2589C18.3828 45.3323 17.4356 45.37 16.4789 45.37C15.5222 45.37 14.5749 45.3323 13.6915 45.2589C12.808 45.1856 12.0059 45.0781 11.331 44.9427C10.6562 44.8072 10.122 44.6465 9.75917 44.4697C9.39631 44.2929 9.21194 44.1035 9.21664 43.9124C9.21194 43.7214 9.39631 43.532 9.75917 43.3552C10.122 43.1784 10.6562 43.0176 11.331 42.8822C12.0059 42.7467 12.808 42.6393 13.6915 42.5659C14.5749 42.4926 15.5222 42.4548 16.4789 42.4548C17.4356 42.4548 18.3828 42.4926 19.2663 42.5659C20.1497 42.6393 20.9519 42.7467 21.6267 42.8822C22.3015 43.0176 22.8357 43.1784 23.1986 43.3552C23.5614 43.532 23.7458 43.7214 23.7411 43.9124Z" fill="#74788D"/>
            <path d="M15.9967 0.5L15.9961 0.500001C7.44403 0.511822 0.5 7.33046 0.5 15.758C0.5 21.3296 3.53649 26.1989 8.0632 28.8613C12.229 31.9189 15.0443 36.6447 15.4894 42.0262L15.4989 42.1411L15.5578 42.2403L15.5667 42.2552L15.5677 42.257L15.9191 43.1208L16.4329 42.2552L16.4418 42.2403L16.5006 42.1412L16.5101 42.0263C16.9557 36.6442 19.7707 31.9187 23.9368 28.8614C28.4638 26.1993 31.5 21.3296 31.5 15.758C31.5 7.33045 24.556 0.511913 16.0039 0.500001L16.0039 0.500001L15.9998 0.500001L15.9974 0.500001H15.9969L15.9967 0.5Z" fill="white" stroke="white"/>
            <path d="M29 16C29 19.4478 27.6304 22.7544 25.1924 25.1924C22.7544 27.6304 19.4478 29 16 29C12.5522 29 9.24558 27.6304 6.80761 25.1924C4.36964 22.7544 3 19.4478 3 16C3 12.5522 4.36964 9.24559 6.80761 6.80761C9.24558 4.36964 12.5522 3 16 3C19.4478 3 22.7544 4.36964 25.1924 6.80761C27.6304 9.24559 29 12.5522 29 16Z" fill="#FFBA5A"/>
            ${svg}
            <circle cx="16" cy="16" r="14" stroke="white" stroke-width="2"/>
        </svg>
    `;
};

const createOfflinelIcon = (svg) => {
	return `
        <svg width="100" height="100" viewBox="0 0 32 46" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path opacity="0.25" d="M23.7411 43.9124C23.7458 44.1035 23.5614 44.2929 23.1986 44.4697C22.8357 44.6465 22.3015 44.8072 21.6267 44.9427C20.9519 45.0781 20.1497 45.1856 19.2663 45.2589C18.3828 45.3323 17.4356 45.37 16.4789 45.37C15.5222 45.37 14.5749 45.3323 13.6915 45.2589C12.808 45.1856 12.0059 45.0781 11.331 44.9427C10.6562 44.8072 10.122 44.6465 9.75917 44.4697C9.39631 44.2929 9.21194 44.1035 9.21664 43.9124C9.21194 43.7214 9.39631 43.532 9.75917 43.3552C10.122 43.1784 10.6562 43.0176 11.331 42.8822C12.0059 42.7467 12.808 42.6393 13.6915 42.5659C14.5749 42.4926 15.5222 42.4548 16.4789 42.4548C17.4356 42.4548 18.3828 42.4926 19.2663 42.5659C20.1497 42.6393 20.9519 42.7467 21.6267 42.8822C22.3015 43.0176 22.8357 43.1784 23.1986 43.3552C23.5614 43.532 23.7458 43.7214 23.7411 43.9124Z" fill="#74788D"/>
            <path d="M15.9967 0.5L15.9961 0.500001C7.44403 0.511822 0.5 7.33046 0.5 15.758C0.5 21.3296 3.53649 26.1989 8.0632 28.8613C12.229 31.9189 15.0443 36.6447 15.4894 42.0262L15.4989 42.1411L15.5578 42.2403L15.5667 42.2552L15.5677 42.257L15.9191 43.1208L16.4329 42.2552L16.4418 42.2403L16.5006 42.1412L16.5101 42.0263C16.9557 36.6442 19.7707 31.9187 23.9368 28.8614C28.4638 26.1993 31.5 21.3296 31.5 15.758C31.5 7.33045 24.556 0.511913 16.0039 0.500001L16.0039 0.500001L15.9998 0.500001L15.9974 0.500001H15.9969L15.9967 0.5Z" fill="white" stroke="white"/>
            <path d="M29 16C29 19.4478 27.6304 22.7544 25.1924 25.1924C22.7544 27.6304 19.4478 29 16 29C12.5522 29 9.24558 27.6304 6.80761 25.1924C4.36964 22.7544 3 19.4478 3 16C3 12.5522 4.36964 9.24559 6.80761 6.80761C9.24558 4.36964 12.5522 3 16 3C19.4478 3 22.7544 4.36964 25.1924 6.80761C27.6304 9.24559 29 12.5522 29 16Z" fill="#C4CCD5"/>
            ${svg}
            <circle cx="16" cy="16" r="14" stroke="white" stroke-width="2"/>
        </svg>
    `;
};

export { getIconUrl, getSvgIconUrl };
